import axios from 'axios';

const getCep = async (cep) => {
  const promise = axios.get(`https://viacep.com.br/ws/${cep}/json/`);
  const dataPromise = promise.then((response) => response.data).catch(err => console.log(err));

  return dataPromise;
}

export default getCep;